import { DataBean } from "../DataBean";

export class PayrollDocumentCatalog extends DataBean {


    public async getPayrollDocumentCatalog(idContract:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPayrollDocumentCatalog_Number", [idContract]);
    }
   
  public async addPayrollDocument(idContract:any,idPayrollDocumentType:any,media:any,mediaContext:any,observations:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.employees.PayrollDocument_addPayrollDocument_Number_Number_String_String_String_Number", [idContract,idPayrollDocumentType,media,mediaContext,observations,idEmployee]);
    }
    

 
}